import Navbar from '../home/components/Navbar';
import ManualApplicationForm from './components/ManualApplicationForm';

/**
 * 人工申请页：为无法完成自助注册的用户提供人工开通账号入口。
 * 表单提交至公开接口 POST /manual-application，审核由管理员在后台完成；
 * 后端不提供进度查询接口，提交后展示等待审核提示。
 */
export default function ManualApplicationPage() {
  return (
    <div className="min-h-screen bg-[#f8fafa]">
      <Navbar />

      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-5 md:py-8 pb-24 md:pb-8">
        {/* 页头 */}
        <div className="mb-6 md:mb-8">
          <h1 className="text-xl md:text-2xl font-bold text-gray-900">人工申请</h1>
          <p className="text-sm text-gray-400 mt-1">提交您的资料，由管理员人工协助开通账号</p>
        </div>

        <div className="max-w-2xl">
          <ManualApplicationForm />
        </div>
      </div>
    </div>
  );
}
